import { FixedVariableDefault } from '../utils/variableTypes';
import { toLabel } from '../utils/variableUtils';
import VariableFieldLabel from './WizardFieldLabel';
import { Input } from '../../ui/input';

interface FixedVariableFieldProps {
    def: FixedVariableDefault;
    value: string;
    isRemovable: boolean;
    onRemove: () => void;
    onChange: (value: string) => void;
}

export default function FixedVariableField({
    def,
    value,
    isRemovable,
    onRemove,
    onChange,
}: FixedVariableFieldProps) {
    const label = def.label || toLabel(def.name);

    switch (def.field) {
        case 'number':
            return (
                <div className="space-y-1.5">
                    <VariableFieldLabel
                        label={label}
                        required={def.required}
                        removable={isRemovable}
                        onRemove={onRemove}
                    />
                    <Input
                        type="number"
                        min={1}
                        placeholder={def.placeholder}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </div>
            );

        case 'text':
        default:
            return (
                <div className="space-y-1.5">
                    <VariableFieldLabel
                        label={label}
                        required={def.required}
                        removable={isRemovable}
                        onRemove={onRemove}
                    />
                    <Input
                        placeholder={def.placeholder}
                        value={value}
                        maxLength={250}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </div>
            );
    }
}
